import React, { useEffect, useRef, useState } from 'react';
import { FaArrowUpRightFromSquare, FaHouseUser } from 'react-icons/fa6';
import api from '../assets/images/skills/api.png';
import bootstrap from '../assets/images/skills/bootStrap.png';
import css from '../assets/images/skills/css.png';
import express from '../assets/images/skills/express.png';
import firebase from '../assets/images/skills/firebase.png';
import github from '../assets/images/skills/github.png';
import html from '../assets/images/skills/html.png';
import javaScritp from '../assets/images/skills/javaScripte.png';
import mono from '../assets/images/skills/mono.png';
import monogo from '../assets/images/skills/monogo.png';
import mui from '../assets/images/skills/mui.png';
import nestJs from '../assets/images/skills/nest.png';
import nextjs from '../assets/images/skills/nextjs.png';
import node from '../assets/images/skills/node.png';
import npm from '../assets/images/skills/npm.png';
import pnpm from '../assets/images/skills/pnpm.png';
import react from '../assets/images/skills/react.png';
import Sqllite from '../assets/images/skills/Sqllite.png';
import tailwind from '../assets/images/skills/tailwind.png';
import ts from '../assets/images/skills/typescripte.png';
import vite from '../assets/images/skills/vite.png';

import { Link } from 'react-router-dom';
import backend_dev from '../assets/images/backend_development.png';
import data_analysis from '../assets/images/data_analysis.png';
import frontend_dev from '../assets/images/frontend_development.png';
import web_dev from '../assets/images/web_development.png';
import mobileApp from '../assets/images/Mobile-App-Development.png';

import wexperience1 from '../assets/images/kaj-logo-white.png';
import project1 from '../assets/images/project1.webp';
import project2 from '../assets/images/project2.webp';
import project3 from '../assets/images/project3.webp';
import project4 from '../assets/images/project4.webp';
import project5 from '../assets/images/project5.webp';
import Navbar from '../components/body_nav';
import Slider from '../components/slider';
import axios from 'axios';
import MiniLoader from '../components/loader';

function Home() {
  const [projects, setProjects] = useState([]);
  const [isloading, setIsloading] = useState(false)
  const fetchProjects = async () => {
    setIsloading(true)
    try {
      const response = await axios.get(
        'https://port-folio-back-end.vercel.app/api/admin/getAllProjects'
      );
      const imageLinks = response.data.map((project) => project.image);
      setProjects(imageLinks);
    } catch (error) {
      console.error(error);
    }
    finally{
      setIsloading(false)
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  const work_experience = [
    {
      period: 'September 2023 - Present',
      img: wexperience1,
      company: 'kaj Consultancy',
      role: 'Front End Developer - Front End Web Development',
    },
    {
      period: 'December 2022 - December 2023',
      img: wexperience1,
      company: 'Matrix Tech Software Solutions',
      role: 'MERN Stack Developer',
    },
    {
      period: 'December 2022 - August 2023',
      img: wexperience1,
      company: 'Jawan Pakistan',
      role: 'Assistant Teacher - MERN Stack Development',
    },
    {
      period: 'December 2022 - December 2023',
      img: wexperience1,
      company: 'Matrix Tech Software Solutions',
      role: 'React Native Developer',
    },
  ];

  const recent_projects = [project1, project2, project3, project4, project5];

  const skills = [
    { img: html, name: 'Html' },
    { img: css, name: 'CSS' },
    { img: javaScritp, name: 'JavaScritp' },
    { img: ts, name: 'TypeScript' },
    { img: react, name: 'React' },
    { img: vite, name: 'ViteJs' },
    { img: nextjs, name: 'NextJs' },
    { img: tailwind, name: 'Tailwind' },
    { img: mui, name: 'Material Ui' },
    { img: bootstrap, name: 'Bootstrap' },
    { img: node, name: 'NodeJS' },
    { img: express, name: 'ExpressJS' },
    { img: nestJs, name: 'NestJs' },
    { img: api, name: 'RestApi' },
    { img: monogo, name: 'MonogoDB' },
    { img: Sqllite, name: 'SQLlite' },
    { img: firebase, name: 'FireBase' },
    { img: github, name: 'GitHub' },
    { img: mono, name: 'MonoRepo' },
    { img: pnpm, name: 'Pnpm' },
    { img: npm, name: 'Npm' },
  ];
  const experties = [
    { img: frontend_dev, name: 'Frontend Development' },
    { img: backend_dev, name: 'Backend Development' },
    { img: web_dev, name: 'Web Development' },
    { img: mobileApp, name: 'Mobile App Development' },
  ];

  const trackRef = useRef(null);
  const currentIndexRef = useRef(3);
  useEffect(() => {
    const track = trackRef.current;
    const slides = Array.from(track.children);
    const slideWidth = slides[0].getBoundingClientRect().width;
    // Clone slides for infinite loop
    const firstClone = slides[0].cloneNode(true);
    const secondClone = slides[1].cloneNode(true);
    const thirdClone = slides[2].cloneNode(true);
    const lastClone = slides[slides.length - 1].cloneNode(true);
    const secondLastClone = slides[slides.length - 2].cloneNode(true);
    const thirdLastClone = slides[slides.length - 3].cloneNode(true);
    track.appendChild(firstClone);
    track.appendChild(secondClone);
    track.appendChild(thirdClone);
    track.insertBefore(lastClone, slides[0]);
    track.insertBefore(secondLastClone, slides[0]);
    track.insertBefore(thirdLastClone, slides[0]);
    const allSlides = Array.from(track.children);
    // Set slide positions after all clones are added
    const setSlidePosition = (slide, index) => {
      slide.style.left = slideWidth * index + 'px';
    };
    allSlides.forEach(setSlidePosition);
    const moveToSlide = (targetIndex) => {
      track.style.transition = 'transform 0.3s ease-in-out';
      track.style.transform = 'translateX(-' + slideWidth * targetIndex + 'px)';
      currentIndexRef.current = targetIndex;
    };
    const nextSlide = () => {
      if (currentIndexRef.current >= allSlides.length - 3) {
        currentIndexRef.current = 3;
        track.style.transition = 'none';
        track.style.transform =
          'translateX(-' + slideWidth * currentIndexRef.current + 'px)';
        setTimeout(() => {
          moveToSlide(currentIndexRef.current + 2);
        }, 50);
      } else {
        moveToSlide(currentIndexRef.current + 2);
      }
    };
    // Automatically move to the next slide every 2 seconds
    const interval = setInterval(nextSlide, 2000);
    // Clean up interval on component unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Navbar title={'Home'} icon={<FaHouseUser />} />

      <div className="flex gap-2 flex-col md:flex-row h-fit pr-2 overflow-y-auto">
        <div className="flex flex-col justify-between gap-4 md:w-[45%] mb-2">
          <div class="font font-wrap text-[1rem] md:text-[1.5rem] font-bold text-lightgrey md:pt-2 pb-2">
            <h4>From Idea to Implementation</h4>
            <p>Comprehensive Digital Expertise</p>
          </div>
          {/* <div class="text-3xl font-bold text-lightgrey">
            <h1>From Concept to Code:</h1>
            <p>Expertise Across the Digital Landscape</p>
          </div> */}

            {isloading ? <div className='flex justify-center mt-4 h-fit'> <MiniLoader size={30} /></div> :
          <div class="bg-primary p-3 rounded-md md:w-[95%]">
            <div className="flex justify-between">
              <h2 className="text-lightgrey text-xl font-bold items-center ">
                Recent Projects
              </h2>
              <Link to="/projects">
                <FaArrowUpRightFromSquare className=" text-xl font-bold items-center text-seagreen" />
              </Link>
            </div>


            <div className="mt-4 h-fit">
              <Slider images={projects} />
            </div>
          </div>
            }
        </div>

        <div className="flex flex-col gap-2 md:pr-3 md:w-[55%]">
          {/* <div className="flex flex-col md:h-[40vh] bg-primary px-3 py-3 rounded-md">
            <div className="flex justify-between">
              <h2 className="text-lightgrey text-xl font-bold items-center ">
                Skills
              </h2>

            </div>

            <div className="flex justify-center my-4 gap-2 md:overflow-y-auto">
              {skills.map((item, index) => (
                <div className="flex flex-col gap-2 items-center justify-center bg-secondary py-3 rounded-md">
                  <div className="flex justify-center w-28 ">
                    <img src={item.img} alt="skill" className="w-12" />
                  </div>
                  <h3 className="text-lightgrey">{item.name}</h3>
                </div>
              ))}
            </div>
          </div> */}

          <div className="flex flex-col bg-primary px-3 py-3 rounded-md">
            <div className="flex justify-between">
              <h2 className="text-lightgrey text-xl font-bold items-center">
                Skills{' '}
                <span className="bg-lightgrey px-2 rounded-full text-primary">
                  {skills?.length}
                </span>
              </h2>
              <Link to="/about">
                <FaArrowUpRightFromSquare className="text-xl font-bold items-center text-seagreen" />
              </Link>
            </div>

            <div className="relative my-4 overflow-hidden">
              <div
                ref={trackRef}
                className="flex transition-transform duration-100"
              >
                {skills?.map((item, index) => (
                  <div key={index} className="flex-shrink-0 w-1/3 px-2">
                    <div className="flex flex-col gap-2 items-center justify-center bg-secondary py-3 rounded-md">
                      <div className="flex justify-center w-28">
                        <img src={item.img} alt="skill" className="w-12" />
                      </div>
                      <h3 className="text-lightgrey">{item.name}</h3>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-2 bg-primary px-3 py-3 rounded-md">
            <div className="flex justify-between">
              <h2 className="text-lightgrey text-xl font-bold items-center ">
                My Expert Area
              </h2>
            </div>
            <div className="flex gap-2 overflow-x-auto h-full py-3">
              {experties.map((item, index) => (
                <div className="flex flex-col flex-wrap items-center bg-secondary px-3 pb-3 rounded-md">
                  <div className="w-28">
                    <img src={item.img} alt="skill" />
                  </div>
                  <h3 className="text-lightgrey">{item.name}</h3>
                </div>
              ))}
            </div>
          </div>

          <div class="bg-primary p-3 rounded-md ">
            <div className="flex justify-between">
              <h2 className="text-lightgrey text-xl font-bold items-center ">
                Work Experience
              </h2>
              <Link to="/about">
                <FaArrowUpRightFromSquare className=" text-xl font-bold items-center text-seagreen" />
              </Link>
            </div>
            <div className="flex flex-col h-fit overflow-y-auto">
              {work_experience.map((item, index) => (
                <div className="flex my-4 flex-row items-center">
                  <div class="flex w-auto flex-col justify-center">
                    <h4 class="text-md font-bold text-lightgrey">
                      {item.company}
                    </h4>
                    <p class="font-medium text-darkgrey">{item.role}</p>
                    <p className="text-lightgrey font-semibold">
                      {item.period}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
